import Swiper from 'swiper/bundle';

export default () => {
  if(document.querySelector('.featured__amount')){

    var swiperFeatured = Swiper;
    var init = false;

    swiperMode();
  
    window.addEventListener('resize', function() {
      swiperMode();
    });

    function swiperMode() {
      let tablet = window.matchMedia('(min-width: 0px) and (max-width: 1024px)');
      let largeDevice = window.matchMedia('(min-width: 1025px)');


      if(tablet.matches) {
        if (!init) {
          init = true;
          swiperFeatured = new Swiper('.featured__amount', {
            slidesPerView: 1,
            freeMode: false,
            mousewheel: false,
            pagination: {
              el: ".featured .swiper-pagination",
              type: "fraction",
            },
            breakpoints: {
              641: {
                slidesPerView: 'auto',
                freeMode: true,
                pagination: false,
              }
            }
          });
        }
      } else if(largeDevice.matches) {
        if (init) {
          swiperFeatured.destroy();
          init = false;
        }
      }
    }
  }
}